import { render } from "./ImageVerification.vue?vue&type=template&id=79c0efb6"
import script from "./ImageVerification.vue?vue&type=script&lang=js"
export * from "./ImageVerification.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__